// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__37U_j","card":"styles_card__2-m1S"};